module.exports = __webpack_public_path__ + "img/movie_thumb.24df9b12.png";